import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MessageService, notCloseMessageOptions } from '../../../../../../core';
import { ArquivoReferencia } from '../../../../referencias';
import { ArquivoUpload } from '../../arquivo-upload';
import { ArquivoUploadModalComponent } from '../modal';

@Component({
    selector: 'sgt-arquivo-upload-card-view',
    templateUrl: 'arquivo-upload-card-view.component.html',
    styleUrls: ['./arquivo-upload-card-view.component.less']
})
export class ArquivoUploadCardViewComponent implements OnInit {
    // Arquivos Upload
    @Input() arquivosUpload: ArquivoUpload[];
    @Output() arquivosUploadChange = new EventEmitter<ArquivoUpload[]>();

    // Config
    @Input() canEdit = true;
    @Input() title = 'Arquivos';
    @Input() headerText: string = null;
    @Input() idTable = 'arquivosTable';

    // Referência
    @Input() referencia: ArquivoReferencia;
    @Input() idReferenciaPai: number;
    @Input() idReferencia: number;

    @ViewChild('uploadModal') uploadModal: ArquivoUploadModalComponent;

    constructor(private messageService: MessageService) { }

    ngOnInit(): void {
        if (!this.arquivosUpload) {
            this.arquivosUpload = [];
        }
    }

    /** Abre o modal para realizar o upload */
    openUploadModal() {
        this.uploadModal.open(this.referencia, this.idReferenciaPai, this.idReferencia);
    }

    /** Ao adicionar um arquivo para o upload */
    onAdd(uploads: ArquivoUpload[]) {
        if (!this.canEdit) {
            this.messageService.warning('Você não tem permissão para adicionar arquivos', 'Acesso Negado', notCloseMessageOptions);
            return false;
        }
        this.arquivosUpload.push(...uploads);
        this.arquivosUploadChange.emit(this.arquivosUpload);
    }

    /** Ao Remover um arquivo do array de arquivos para realizar o upload */
    onDelete(index: number) {
        if (!this.canEdit) {
            this.messageService.warning('Você não tem permissão para remover arquivos', 'Acesso Negado', notCloseMessageOptions);
            return false;
        }

        const arquivo = index >= 0 ? this.arquivosUpload[index] : null;
        if (!arquivo) {
            this.messageService.warning('Verifique o arquivo que você deseja remover e se o problema persistir entre em contato com o suporte', 'Nenhum arquivo para ser removido', notCloseMessageOptions);
            return false;
        }

        this.messageService.confirm(`Deseja realmente remover o arquivo ${arquivo.nome ?? ''} da lista de arquivos?`,  'Confirme').then(result => {
            if (result) {
                try {
                    this.arquivosUpload.splice(index, 1);
                    this.arquivosUploadChange.emit(this.arquivosUpload);
                    this.messageService.success('', `Arquivo ${arquivo.nome ?? ''} removido com sucesso`);
                } catch (error) {
                    this.messageService.error(error.message, `Erro ao remover o arquivo ${arquivo.nome ?? ''}`, error)
                }
            }
        }).
        catch(() => {});
    }
}
